import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { fetchMarket, getWatchlist } from "../lib/api";
import MarketCard from "../components/MarketCard";
import { ArrowLeft, Star } from "@phosphor-icons/react";
import ProtectedRoute from "../auth/ProtectedRoute";

function WatchlistInner() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const wl = await getWatchlist();
        const saved = wl.items || [];
        if (saved.length === 0) {
          setItems([]);
          return;
        }
        // Fetch fresh data for each saved market in parallel
        const fresh = await Promise.all(
          saved.map((w) =>
            fetchMarket(w.id).catch(() => ({
              id: w.id,
              question: w.question,
              image: w.image,
              yesPrice: w.yesPrice,
              noPrice: w.yesPrice != null ? 1 - w.yesPrice : null,
              volume: 0,
              liquidity: 0,
              category: null,
              endDate: null,
            }))
          )
        );
        setItems(fresh);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="watchlist-page">
      <Header />
      <div className="mx-auto max-w-[1400px] px-6 py-10">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-zinc-400 hover:text-white mb-6"
        >
          <ArrowLeft size={14} /> Back
        </Link>

        <div className="flex items-center gap-3 mb-8">
          <Star size={22} weight="duotone" className="text-edge" />
          <h1 className="font-display text-3xl font-medium">Watchlist</h1>
        </div>

        {loading ? (
          <div className="text-zinc-500 font-mono text-xs uppercase tracking-widest">Loading…</div>
        ) : items.length === 0 ? (
          <div className="border border-white/10 p-10 text-center text-zinc-500 font-body">
            No saved markets yet. Star markets from the terminal to track them here.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((m) => (
              <MarketCard key={m.id} market={m} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function Watchlist() {
  return (
    <ProtectedRoute>
      <WatchlistInner />
    </ProtectedRoute>
  );
}
